import { Inject, Injectable } from '@angular/core';

import { Svg } from '@svgdotjs/svg.js';
import { PartInfo } from 'app/collage-designer/collage-designer-config';
import { StageUtils } from 'app/core/utils.stage';
import { DesignStepService
       } from 'collage-designer/design-step/design-step.service';
import { ImagePlaceholder
       } from 'collage-designer/stage/placeholder/image-placeholder';
import { StageService } from 'collage-designer/stage/stage.service';
import { StageConstants } from 'core/constants';
import { QualityRating } from './quality-rating';

@Injectable()
export class ImageQualityRatingService
{
  public constructor(
      @Inject(DesignStepService) private designStepService: DesignStepService,
      @Inject(StageService) private stageService: StageService)
  {}

  public readQualityRating(placeholder: ImagePlaceholder): number|undefined
  {
    const bounds = placeholder.getBoundingBox();
    if (!bounds) {
      return undefined;
    }

    this.updateImageQualityRating(
        placeholder.wrapper,
        bounds.width / placeholder.getMagnification());

    return parseInt(
        placeholder.get(StageConstants.ATTRIBUTE_QUALITY_RATING), 10);
  }

  private updateImageQualityRating(element: Svg, imageWidth: number): void
  {
    element.find('image').at(0).attr(
        StageConstants.ATTRIBUTE_QUALITY_RATING,
        this.calculateImageQualityRating(element, imageWidth));
  }

  private calculateViewboxFactor(info: PartInfo): number
  {
    const referenceSide = (
      this.stageService.getCurrentStageState().stageConfig.rotation % 180 === 0
        ? info.config.width
        : info.config.height);

    return referenceSide / StageUtils.originalDimensions(info.doc).width;
  }

  private findContainingPart(wrapper: Svg): PartInfo
  {
    for (const parent of wrapper.parents()) {
      const partId = parent.attr(StageConstants.ATTRIBUTE_PART_ID);
      const fallbackPart = this.designStepService.getDesignablePart();

      if (partId) {
        return {
          config: this
            .designStepService
            .getParts()
            .filter(p => p.id === partId)[0] || fallbackPart,
          doc: parent as Svg,
        };
      }
    }

    return {
      config: this.designStepService.getPart(),
      doc: (<any>wrapper).root() as Svg,
    };
  }

  private calculateImageQualityRating(
      wrapper: Svg, imageWidth: number): number
  {
    let qualityInPercent = 1;
    if (!this.designStepService
          .getDesignStepConfig().imagePlaceholdersSettings.disableImageRating) {
      const info = this.findContainingPart(wrapper);
      const factor = this.calculateViewboxFactor(info);
      let targetWidth = wrapper.width() as number;
      let group = (<any>wrapper).parent();
      while (group && group.node.tagName === 'g') {
        targetWidth = targetWidth * group.transform().scaleX;
        group = group.parent();
      }
      targetWidth = targetWidth * factor;

      qualityInPercent = imageWidth / targetWidth;
    }
    return QualityRating.getQualityByPercent(qualityInPercent);
  }
}
